<template>
    <b-overlay :show="showOverlay" rounded="sm" class='demolistwrap'>
        <div class="card mt-0 border-0 bg-wash no-shadow demolistwrap2">

            <div class="card-header px-0 bg-transparent border-0">
                <div class="row no-margin"
                     :class="[{ 'company-directory-search-row': is_company_directory === 'yes' }]">
                    <div class="col-sm-6 pl-0"
                         :class="[{ 'company-directory-search': is_company_directory === 'yes' }]">
                        <!-- get active when company directory is "yes" -->
                        <b-button v-if="is_company_directory === 'yes'" id="filter_button"
                                  class="employee-filter-btn mb-1 custom-secodary-btn" v-b-toggle.sidebar_right>
                            <b-icon
                                class="ml-3" icon="funnel-fill"></b-icon>
                            Filter
                        </b-button>

                        <!-- always open search box and year selection group -->
                        <div class="d-flex">
                            <div class="custom-search w-100" style="max-width: 480px;">
                                <b-input-group>
                                    <b-input-group-prepend is-text>
                                        <b-icon icon="search"></b-icon>
                                    </b-input-group-prepend>
                                    <b-form-input type="search" placeholder="Search" v-model="search"
                                                  @input="resetPagination()"></b-form-input>
                                </b-input-group>
                            </div>
                            <div class="ml-3">
                                <!-- <b-form-group id="year-group"
                                              class="required-field"
                                              label-for="year_id">
                                    <b-form-select id="year_id"
                                                   name="year_id"
                                                   @change="getYearData"
                                                   v-model="selectedYear">
                                        <b-form-select-option :options="years">
                                            {{ year }}
                                        </b-form-select-option>
                                    </b-form-select>
                                </b-form-group> -->
                                <b-form-select id="year" name="year" v-model="selected_year" :options="years" @change="resetYear()"></b-form-select>
                            </div>
                            <div class="ml-3">
                                <b-button type="button" variant="secondary">
                                    Import
                                    <b-icon class="ml-3" @click="openUploadModal" icon="upload"></b-icon>
                                </b-button>
                            </div>
                        </div>

                        <!-- get active when company directory is "yes" -->
                        <div class="d-block directory-switch-btns align-top mt-4" v-if="is_company_directory === 'yes'">
                            <div class="d-inline-block">
                                <b-button class="view-mode-btn custom-secodary-btn switch-view-btn"
                                          :class="[{ 'active': viewMode }]" @click="viewMode = true">
                                    <b-icon class="list-icon"
                                            icon="list"></b-icon>
                                </b-button>
                                <b-button class="view-mode-btn custom-secodary-btn switch-view-btn"
                                          @click="viewMode = false" :class="[{ 'active': !viewMode }]">
                                    <b-icon class="grid"
                                            icon="grid"></b-icon>
                                </b-button>
                                <span class="view-mode-status d-block"><template v-if="viewMode">List
                                        View</template><template v-else>Grid View</template></span>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-6 pr-0 trz_ppl_wrapper">
                        <div class="col-12 text-right pr-0 trz_ppl_wrapper_2">
                            <!-- export button for export the employee id -->
                            <b-button v-if="selected.length > 0"
                                      @click="exportEmployee"
                                      class="employee-filter-btn mb-1 custom-secodary-btn">
                                Export
                                <b-icon class="ml-3" icon="download"></b-icon>
                            </b-button>

                            <b-button id="filter_button" class="employee-filter-btn mb-1 custom-secodary-btn"
                                      v-b-toggle.sidebar_right>Filter
                                <b-icon class="ml-3" icon="funnel-fill"></b-icon>
                            </b-button>

                            <!-- get active when switch view is "1" -->
                            <b-button v-if="switch_view === 1"
                                      class="view-mode-btn employee-filter-btn mb-1 custom-secodary-btn switch-view-btn"
                                      @click="viewMode = !viewMode">Switch View
                                <b-icon v-if="viewMode" class="ml-3 list-icon" icon="list-ul"></b-icon>
                                <b-icon v-else class="ml-3 grid-icon" icon="grid3x3-gap-fill"></b-icon>
                            </b-button>

                            <div
                                class="d-inline-block trz_fields trz-custom-dropdown mb-1 position-absolute trz_people_btn"
                                :class="email_class">
                                <div class="pl-0 company-employee-count" style="height: 31px; position: unset;"><span
                                    class="text-center px-2 border border-right-0 d-inline-block h-100 employee-count-icon"><b-icon
                                    class="" icon="people-fill"></b-icon></span><span
                                    class="text-center px-2 border d-inline-block h-100 employee-count-number"
                                    style="min-width: 51px;">{{ people }}</span></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card-body px-0 container">
                <div class="employee-table-wrapper"
                     :class="[{ 'no-overflow' : paginatedData.length < 8 && is_pf != 1 }, tableStickyHeight]"
                     v-if="viewMode">
                    <table class="employee-list-table dataTable table-overflow table-sticky" v-if="viewMode">
                        <thead>
                        <tr class="table-head ">
                            <td v-for="f in default_column">
                                <template v-for="k in default_options">
                                    <template v-if="f === k.value  && f !== 'name'">
                                        <label class="custom-label"
                                               :class="sortKey === k.value ? (sortOrders[k.value] > 0 ? 'sorting_asc' : 'sorting_desc') : 'sorting'"
                                               @click="sortBy(k.value)">
                                            <span>
                                                <template v-if="k.text === 'Jobposition'">Job Position</template>
                                                <template v-else-if="k.text === 'Branch'">Work Location</template>
                                                <template v-else-if="k.text === 'Phone'">Mobile Number</template>
                                                <template v-else>{{ k.text }}</template>
                                            </span>
                                        </label>
                                    </template>
                                    <template v-if="f === k.value  && f === 'name'">
                                        <input v-if="checkbox === 1" type="checkbox" v-model="selectAll" class="">
                                        <label class="custom-label pl-5"
                                               :class="sortKey === k.value ? (sortOrders[k.value] > 0 ? 'sorting_asc' : 'sorting_desc') : 'sorting'"
                                               @click="sortBy(k.value)">
                                            <span v-if="is_company_directory === 'yes'">Employee Name</span>
                                            <span v-else>{{ k.text }}</span>
                                        </label>
                                    </template>
                                </template>
                            </td>
                            <!-- get active when is_payruns is "yes" -->
                            <template v-if="is_payruns === 'yes'">
                                <td class="text-left" v-for="f in column_selected">
                                    <template v-for="k in column_options">
                                        <template v-if="f === k.value">
                                            <label class="custom-label"
                                                   :class="sortKey === k.value ? (sortOrders[k.value] > 0 ? 'sorting_asc' : 'sorting_desc') : 'sorting'"
                                                   @click="sortBy(k.value)">
                                                <span>
                                                    <template v-if="k.text === 'Jobposition'">Job</template>
                                                    <template v-else-if="k.text === 'Branch'">Work Location</template>
                                                    <template v-else-if="k.text === 'Etin'">e-TIN</template>
                                                    <template v-else>{{ k.text }}</template>
                                                </span>
                                            </label>
                                        </template>
                                    </template>
                                </td>
                                <td class="text-center" v-for="f in appended_column">
                                    <template v-for="k in appended_options">
                                        <template v-if="f.value === k.value">
                                            <label class="custom-label"
                                                   :class="sortKey === k.value ? (sortOrders[k.value] > 0 ? 'sorting_asc' : 'sorting_desc') : 'sorting'"
                                                   @click="sortBy(k.value)">
                                                <span>
                                                    <template v-if="k.text === 'Jobposition'">Job Position</template>
                                                    <template v-else-if="k.text === 'Branch'">Work Location</template>
                                                    <template v-else>{{ k.text }}</template></span>
                                            </label>
                                        </template>
                                    </template>
                                </td>
                            </template>
                            <template v-else>
                                <td class="text-center" v-for="f in appended_column">
                                    <template v-for="k in appended_options">
                                        <template v-if="f.value == k.value">
                                            <label class="custom-label"
                                                   :class="sortKey === k.value ? (sortOrders[k.value] > 0 ? 'sorting_asc' : 'sorting_desc') : 'sorting'"
                                                   @click="sortBy(k.value)">
                                                <span>
                                                    <template v-if="k.text == 'Jobposition'">Job Position</template>
                                                    <template v-else-if="k.text == 'Branch'">Work Location</template>
                                                    <template v-else>{{ k.text }}</template>
                                                </span>
                                            </label>
                                        </template>
                                    </template>
                                </td>
                                <td class="text-left" v-for="f in column_selected">
                                    <template v-for="k in column_options">
                                        <template v-if="f == k.value">
                                            <label class="custom-label"
                                                   :class="sortKey === k.value ? (sortOrders[k.value] > 0 ? 'sorting_asc' : 'sorting_desc') : 'sorting'"
                                                   @click="sortBy(k.value)">
                                                <span>
                                                    <template v-if="k.text == 'Jobposition'">Job Position</template>
                                                    <template v-else-if="k.text == 'Branch'">Work Location</template>
                                                    <template v-else>{{ k.text }}</template>
                                                </span>
                                            </label>
                                        </template>
                                    </template>
                                </td>
                            </template>
                            <td v-if="is_action == 1" class="action_thead">Action</td>
                            <td class="action_thead">Action</td>
                        </tr>
                        </thead>
                        <tbody>
                        <tr class="hover-bg table-row" v-for="employee in paginatedData" :key="employee[primary_key]">
                            <template v-if="status_flag">
                                <template v-if="employee.status === 'Active'">
                                    <td class="cursor-pointer trz_relative" v-for="f in default_column">
                                        <template v-if="f === 'phone'">
                                            <span class="cursor-pointer"
                                                  @click="editEmployee(employee[primary_key])">
                                                {{ formatPhoneNumber(employee.phone) }}
                                            </span>
                                        </template>
                                        <template v-else-if="f === 'name'">
                                            <template v-if="edit_icon === 'yes' ">
                                                <b-icon
                                                    v-if="employee.draft_flg == 1 || employee.draft_mph == 1 || employee.draft_mpfh == 1 || employee.draft_contract == 1"
                                                    icon="arrow-right-circle"
                                                    variant="info"
                                                    animation="fade"
                                                    class="mr-1 trz_employee_draft_edit"
                                                    v-b-tooltip.hover
                                                    title="Has Draft Data"/>
                                                <b-icon v-else
                                                        icon="blank"
                                                        class="mr-1 trz_employee_draft_edit"/>
                                            </template>
                                            <template v-if="checkbox === 1">
                                                <input v-if="employee.pay_slip_name && employee.pay_slip_name != ''"
                                                       type="checkbox"
                                                       class="justify-content-center "
                                                       v-model="selected"
                                                       :value="employee[primary_key]"
                                                       number>
                                                <input v-else type="checkbox"
                                                       class="justify-content-center"
                                                       v-model="selected"
                                                       :value="employee.employee_id"
                                                       number>
                                            </template>
                                            <label class="mb-0 custom-label">
                                                <img v-if="employee.pic != ''"
                                                     v-bind:src="pageurl+'/avatar/'+ employee.company_id + '/' + employee.pic"
                                                     class="img-fluid img-thumbnail employee-avatar mx-2"/>
                                                <img v-else
                                                     v-bind:src="pageurl+'/avatar/demo.jpg'"
                                                     class="img-fluid img-thumbnail employee-avatar mx-2"/>
                                                <template v-if="employee.pay_slip_name && employee.pay_slip_name !=''">
                                                    <span style="color: rgb(29, 104, 167);"
                                                          class="cursor-pointer"
                                                          @click="editEmployee(employee[primary_key])">
                                                        {{ employee.name }}
                                                    </span>
                                                </template>
                                                <template v-else>
                                                    <span class="cursor-pointer"
                                                          @click="editEmployee(employee[primary_key])">
                                                        {{ employee.name }}
                                                    </span>
                                                </template>
                                            </label>
                                        </template>
                                        <template v-else>{{ employee[f] }}</template>
                                    </td>
                                    <template v-if="is_payruns === 'yes'">
                                        <td class="cursor-pointer text-left"
                                            v-for="f in column_selected">
                                            <template v-if="f !== 'name'">
                                                <span class="cursor-pointer"
                                                      @click="editEmployee(employee[primary_key])">
                                                    {{ employee[f] }}
                                                </span>
                                            </template>
                                        </td>
                                        <td class="cursor-pointer text-left" v-for="f in appended_column">
                                            <template v-if="employee.pay_slip_name && employee.pay_slip_name !== ''">
                                                <span v-if="f.value === 'reviewed'" class="text-center d-block"><template
                                                    v-if="parseInt(employee[f.value]) === 1"><b-icon
                                                    icon="check-circle-fill"
                                                    class="ml-2"
                                                    variant="success"></b-icon></template><template
                                                    v-else></template></span>
                                                <span v-else class="text-right d-block">{{ employee[f.value] }}</span>
                                            </template>
                                            <template v-else>
                                                <template><span class="cursor-pointer"
                                                                @click="editEmployee(employee[primary_key])">{{
                                                        employee[f.value]
                                                    }}</span>
                                                </template>
                                            </template>
                                        </td>
                                    </template>
                                    <template v-else>
                                        <td class="cursor-pointer text-left" v-for="f in appended_column">
                                            <template v-if="employee.pay_slip_name && employee.pay_slip_name !=''">
                                                <span class="text-right d-block">{{ employee[f.value] }}</span>
                                            </template>
                                            <template v-else>
                                                <template><span class="cursor-pointer"
                                                                @click="editEmployee(employee[primary_key])">{{
                                                        employee[f.value]
                                                    }}</span>
                                                </template>
                                            </template>
                                        </td>
                                        <td class="cursor-pointer text-left" v-for="f in column_selected">
                                            <!-- <template v-if="f != 'name' && f != 'email' && f != 'phone' && f != 'department' && f != 'jobposition' && f != 'branch'"> -->
                                            <template><span class="cursor-pointer"
                                                            @click="editEmployee(employee[primary_key])">{{
                                                    employee[f]
                                                }}</span>
                                            </template>
                                        </td>
                                    </template>

                                    <td v-if="is_action==1 && employee.actions.length > 0" class="action_td">
                                        <div class="col-sm-2 py-1 pl-0 pr-3 float-right">
                                            <a id="actionDropdown"
                                               class="dropdown-toggle clearfix action-dropdown-toggle"
                                               style="font-size: 16px;" href="#" role="button" data-toggle="dropdown"
                                               aria-haspopup="true" aria-expanded="false">
                                                <b-icon icon="three-dots-vertical"></b-icon>
                                            </a>
                                            <div class="dropdown-menu action-dropdown-menu"
                                                 aria-labelledby="actionDropdown">
                                                <b-button-group>
                                                    <div v-for="(row, index) in employee.actions" :key="index">
                                                        <b-button variant="outline-secondary"
                                                                  @click="actionEmployee(employee[primary_key],row.value)">
                                                            <b-icon v-if="row.label == 'Review'"
                                                                    icon="pencil-square"></b-icon>
                                                            <b-icon v-else-if="row.label == 'Preview Taxcard'"
                                                                    icon="eye"></b-icon>
                                                            <b-icon v-else icon="gear"></b-icon>
                                                            {{ row.label }}
                                                        </b-button>
                                                    </div>
                                                </b-button-group>
                                            </div>
                                        </div>
                                    </td>
                                    <td v-else-if="is_action==1 && employee.actions.length == 0" class="action_td">
                                        <div class="col-sm-2 py-1 pl-0 pr-3 float-right">

                                        </div>
                                    </td>
                                </template>
                            </template>

                            <template v-else>
                                <td class="cursor-pointer trz_relative" v-for="f in default_column">
                                    <template v-if="f === 'phone'">
                                        <span class="cursor-pointer"
                                              @click="editEmployee(employee[primary_key])">
                                            {{ formatPhoneNumber(employee.phone) }}
                                        </span>
                                    </template>
                                    <template v-else-if="f === 'name'">
                                        <template v-if="edit_icon === 'yes'">
                                            <b-icon
                                                v-if="employee.draft_flg == 1 || employee.draft_mph == 1 || employee.draft_mpfh == 1 || employee.draft_contract == 1"
                                                icon="arrow-right-circle" variant="info" animation="fade"
                                                class="mr-1 trz_employee_draft_edit" v-b-tooltip.hover
                                                title="Has Draft Data"></b-icon>
                                            <b-icon v-else icon="blank" class="mr-1 trz_employee_draft_edit"></b-icon>
                                        </template>
                                        <template v-if="checkbox==1 ">
                                            <input v-if="employee.pay_slip_name && employee.pay_slip_name !=''"
                                                   type="checkbox"
                                                   class="justify-content-center" v-model="selected"
                                                   :value="employee[primary_key]" number>
                                            <input v-if="employee.locked ==1"
                                                   type="checkbox"
                                                   :disabled="employee.locked ==1"
                                                   class="justify-content-center trz_disable_box"
                                                   v-model="selected"
                                                   :value="employee[primary_key]"
                                                   number>
                                            <input v-else
                                                   type="checkbox"
                                                   class="justify-content-center"
                                                   v-model="selected"
                                                   :value="employee[primary_key]"
                                                   number>
                                        </template>
                                        <label class="mb-0 custom-label">
                                            <img v-if="employee.pic != ''"
                                                 v-bind:src="pageurl+'/avatar/'+ employee.company_id + '/' + employee.pic"
                                                 class="img-fluid img-thumbnail employee-avatar mx-2"/>
                                            <img v-else v-bind:src="pageurl+'/avatar/demo.jpg'"
                                                 class="img-fluid img-thumbnail employee-avatar mx-2"/>
                                            <template v-if="employee.pay_slip_name && employee.pay_slip_name !=''">
                                                <span v-if="$acl['createpayslipbyid'] == 2"
                                                      style="color: rgb(29, 104, 167);" class="cursor-pointer"
                                                      @click="editEmployee(employee[primary_key])">
                                                    {{ employee.name }}
                                                </span>
                                                <span v-else style="color: rgb(29, 104, 167);"
                                                      class="">
                                                    {{ employee.name }}
                                                </span>
                                            </template>
                                            <template v-else>
                                                <span class="cursor-pointer"
                                                      @click="editEmployee(employee[primary_key])">
                                                    {{ employee.name }} (marked)
                                                </span>
                                            </template>
                                        </label>
                                    </template>
                                    <template v-else>{{ employee[f] }}</template>
                                </td>
                                <template v-if="is_payruns === 'yes'">
                                    <td class="cursor-pointer text-left" v-for="f in column_selected">
                                        <template v-if="f != 'name'">
                                            <span class="cursor-pointer"
                                                  @click="editEmployee(employee[primary_key])">
                                                {{ employee[f] }}
                                            </span>
                                        </template>
                                    </td>
                                    <td class="cursor-pointer text-left" v-for="f in appended_column">
                                        <template v-if="employee.pay_slip_name && employee.pay_slip_name != ''">
                                            <span v-if="f.value === 'reviewed'"
                                                  class="text-center d-block">
                                                <template v-if="parseInt(employee[f.value]) === 1">
                                                    <b-icon icon="check-circle-fill"
                                                            class="ml-2"
                                                            variant="success">
                                                    </b-icon>
                                                </template>
                                                <template v-else></template>
                                            </span>
                                            <span v-else class="text-right d-block">
                                                {{ employee[f.value] }}
                                            </span>
                                        </template>
                                        <template v-else>
                                            <template>
                                                <span class="cursor-pointer"
                                                      @click="editEmployee(employee[primary_key])">
                                                    {{ employee[f.value] }}
                                                </span>
                                            </template>
                                        </template>
                                    </td>
                                </template>
                                <template v-else>
                                    <td class="cursor-pointer text-left" v-for="f in appended_column">
                                        <template v-if="employee.pay_slip_name && employee.pay_slip_name !=''">
                                            <span class="text-right d-block">{{ employee[f.value] }}</span>
                                        </template>
                                        <template v-else>
                                            <template><span class="cursor-pointer"
                                                            @click="editEmployee(employee[primary_key])">{{
                                                    employee[f.value]
                                                }}</span>
                                            </template>
                                        </template>
                                    </td>
                                    <td class="cursor-pointer text-left" v-for="f in column_selected">
                                        <!-- <template v-if="f != 'name' && f != 'email' && f != 'phone' && f != 'department' && f != 'jobposition' && f != 'branch'"> -->
                                        <template><span class="cursor-pointer"
                                                        @click="editEmployee(employee[primary_key])">{{
                                                employee[f]
                                            }}</span>
                                        </template>
                                    </td>
                                </template>
                                <td v-if="is_action==1 && employee.actions.length > 0" class="action_td">
                                    <div class="col-sm-2 py-1 pl-0 pr-3 float-right">
                                        <a id="actionDropdown" class="dropdown-toggle clearfix action-dropdown-toggle"
                                           style="font-size: 16px;" href="#" role="button" data-toggle="dropdown"
                                           aria-haspopup="true" aria-expanded="false">
                                            <b-icon icon="three-dots-vertical"></b-icon>
                                        </a>
                                        <div class="dropdown-menu action-dropdown-menu"
                                             aria-labelledby="actionDropdown">
                                            <b-button-group>
                                                <div v-for="(row, index) in employee.actions" :key="index">
                                                    <b-button variant="outline-secondary"
                                                              @click="actionEmployee(employee[primary_key],row.value)">
                                                        <b-icon v-if="row.label == 'Review'"
                                                                icon="pencil-square"></b-icon>
                                                        <b-icon v-else-if="row.label == 'Preview Taxcard'"
                                                                icon="eye"></b-icon>
                                                        <b-icon v-else-if="row.label == 'Locked'"
                                                                icon="lock-fill"></b-icon>

                                                        <b-icon v-else icon="gear"></b-icon>
                                                        {{ row.label }}
                                                    </b-button>

                                                </div>

                                            </b-button-group>
                                        </div>
                                    </div>
                                </td>
                                <td v-else-if="is_action==1 && employee.actions.length == 0" class="action_td">
                                    <div class="col-sm-2 py-1 pl-0 pr-3 float-right">

                                    </div>
                                </td>

                                <td class="float-right">
                                    <b-button variant="outline-primary"
                                              @click="openCostMappingModal(employee.employee_id)"
                                              size="sm">Map Cost
                                    </b-button>
                                    
                                </td>
                            </template>

                        </tr>
                        </tbody>
                    </table>
                </div>
                <!--</div>-->
                <!--</div>-->
                <!-- list view ends here -->
                <!-- grid view starts here -->
                <div class="grid-view my-3 clearfix employee-grid-view" v-else>
                    <div class="container-fluid px-0">
                        <div class="grid">
                            <div class="grid-item hover-bg overflow-hidden" v-for="employee in paginatedData"
                                 :key="employee[primary_key]">
                                <div class="grid-employee-img">
                                    <img v-if="employee.pic != ''"
                                         v-bind:src="pageurl+'/avatar/'+ employee.company_id + '/' + employee.pic"
                                         class="img-fluid img-thumbnail"/>
                                    <img v-else v-bind:src="pageurl+'/avatar/demo.jpg'"
                                         class="img-fluid img-thumbnail"/>
                                </div>
                                <div class="grid-employee-data text-center">
                                    <span>{{ employee.name }}</span>
                                    <span>{{ employee.jobposition }}<span
                                        v-if="employee.department !== '' && employee.jobposition !== ''">, </span> {{
                                            employee.department
                                        }}</span>
                                </div>
                                <div v-if="is_company_directory == 'yes'"
                                     class="grid-hover-wrapper position-absolute p-2 w-100 h-100 d-flex justify-content-center align-items-center text-center">
                                    <div class="grid-hover-wrapper-inner">
                                        <span class="grid-emp-title d-block">{{ employee.name }}</span>
                                        <span class="d-block">{{ employee.jobposition }}<span
                                            v-if="employee.department !== '' && employee.jobposition !== ''">, </span>
                                            {{ employee.department }}</span>
                                        <hr/>
                                        <span class="d-block">
                                            Contact: <b>{{ formatPhoneNumber(employee.phone) }}</b>
                                        </span>
                                        <span class="d-block">
                                            Email: <b>{{ employee.email }}</b></span>
                                        <span class="d-block">Employee Code: {{ employee.employee_code }}</span>
                                    </div>
                                </div>
                                <div class="grid-employee-viewmore mt-4">
                                    <b-button variant="primary" class="w-100" title="Edit" v-if="viewMode==false"
                                              @click="editEmployee(employee[primary_key])">View Details
                                    </b-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- grid view ends here -->
                <div class="row py-2 no-margin" v-if="paginatedData.length > 0">
                    <div class="col-md-12 p-0 no-margin" v-if="paginatedData.length > 0">
                        <ul class="pagination b-pagination float-left mb-0 mt-1">
                            <li class="page-item disabled m-2">View</li>
                            <li class="page-item disabled">
                                <b-form-select v-model="temp_length" :options="length_options"
                                               @change="setFirstPage()"></b-form-select>
                            </li>
                            <li class="page-item disabled m-2">per page. Total {{ people }} records found.</li>
                        </ul>
                        <b-pagination-nav class="float-right mt-1" v-model="pagination.currentPage"
                                          :number-of-pages="pagination.pages" prev-text="Previous" next-text="Next"
                                          base-url="#" first-number last-number></b-pagination-nav>
                    </div>

                </div>
                <div v-if="paginatedData.length == 0" class="px-3 py-3 no-result-cell text-center">
                    <span class="d-block text-center">{{ blankMsg }}</span>
                    <img v-if="show_loader" v-bind:src="pageurl+'/images/download-loader.svg'" class="loader-logo"
                         width="100px"/>
                </div>
            </div>

            <b-sidebar id="sidebar_right" title="Filter" right shadow>
                <filter-list :pageurl="this.pageurl" :key="sidebar_key" :company_options="company_options"
                             :search_by_filter="search_by_filter" :default_column="default_column"
                             :column_selected="column_selected" v-on:childToParent="filterList"></filter-list>
            </b-sidebar>


            <div>
                <!-- Employee Policy Modal -->
                <b-modal id="bv-modal-employee-cost-mapping" size="lg" hide-footer title="Details">
                    <cost-mapping
                        :employeeID="employeeID"
                        @close-cost-mapping-modal="closeCostMappingModal"></cost-mapping>
                </b-modal>

                <!-- Employee Policy Modal -->
                <b-modal id="bv-modal-employee-policy" size="md" hide-footer title="Update Employee Policy">
                    <policy-mapping
                        :employeeID="employeeID"
                        @clicked-closed-policy-mapping-modal="closePolicyMappingModal"></policy-mapping>
                </b-modal>

                <!-- Employee Leave Apply Modal -->
                <b-modal id="bv-modal-employee-apply-leave" size="lg" hide-footer title="Application for Leave">
                    <leave-apply
                        :employeeID="employeeID">
                    </leave-apply>
                </b-modal>

                <!-- Employee Device Modal -->
                <b-modal id="bv-modal-employee-device" size="sm" hide-footer title="Employee Device">
                    <attendance-employee-device
                        @close-employee-device-modal="closeEmployeeDeviceModal"
                        :employeeID="employeeID">
                    </attendance-employee-device>
                </b-modal>

                <!-- File Upload Modal -->
                <b-modal id="bv-modal-file-upload" size="sm" hide-footer title="Upload File">
                    <b-form @submit.stop.prevent="importData">
                        <b-form-file
                            v-model="file"
                            ref="file"
                            :state="Boolean(file)"
                            @change="uploadFile"
                            placeholder="Choose a file..."
                            drop-placeholder="Drop file..."
                        ></b-form-file>

                        <b-button type="submit" class="mt-4">
                            Upload
                        </b-button>

                    </b-form>
                </b-modal>
            </div>
        </div>
    </b-overlay>
</template>


<script>
import moment from "moment";

export default {
    props: [
        'pageurl',
        'employees',
        'default_column',
        'appended_column',
        'company_options',
        'primary_key',
        'email_class',
        'checkbox',
        'is_action',
        'is_pf', //need to talk about pf. parent does not have it
        'payslipids',
        'switch_view',
        'is_payruns',
        'all_employee',
        'is_company_directory',
        'edit_icon'
    ],

    data() {

        let sortOrders = {};

        //columns.forEach((column) => {sortOrders[column.name] = -1;});

        return {
            file: null,

            columns: [],
            sortKey: 'name',
            sortOrders: sortOrders,

            tmp_column_selected: [],
            column_selected: [], // Must be an array reference!
            default_options: [],
            appended_options: [],
            column_options: [],
            search_by_filter: [],
            selected: [],
            backdoor: 0,
            sidebar_key: 0,
            selected_ids: [],
            showOverlay: true,
            viewMode: true, // need to discuss 'view mode, already have in parent component'
            notice: "",
            blankMsg: 'Fetching data..',
            people: 0,
            company_name: '',
            // pgurl: this.pageurl,
            filter_by_id: ['jobposition_id', 'department_id', 'branch_id'],
            search: '',
            length: 20,
            temp_length: 20,
            length_options: [],
            pagination: {currentPage: 1, total: '', nextPage: '', prevPage: '', from: '', to: '', pages: 1},
            status_flag: false,
            show_loader: false,
            tableStickyHeight: '',


            employeeID: null,


            //custom sid-dev
            selectedYear: moment().year(),
            // allApprovedYears: this.$root.getLeaveYear(),
                        
            years: [
                    { text: '2019', value: '2019' },
                    { text: '2020', value: '2020' },
                    { text: '2021', value: '2021' },
                    { text: '2022', value: '2022' },
                    { text: '2023', value: '2023' },
                    { text: '2024', value: '2024' },
                    { text: '2025', value: '2025' },
                    { text: '2026', value: '2026' },
                ],

        }
    },
    methods: {
        importData() {
            if (!this.checkNet()) return false;
            this.showOverlay = true;
            let currentObj = this;

            const formData = new FormData();
            formData.append('file', this.file);
            const headers = {'Content-Type': 'multipart/form-data'};

            axios.post('import-cost-mapping', formData, {headers})
                .then(function (response) {
                    this.$bvModal.hide("bv-modal-file-upload");
                    this.$emit('refresh-list', "");
                    if (response.data?.errors) {
                        this.$bvToast.toast(response.data?.errors[0], {
                            title: `Error!`,
                            variant: 'danger',
                            solid: true,
                            toaster: 'b-toaster-top-right'
                        });
                    }
                    currentObj.showOverlay = false;
                }.bind(this)).catch(function (error) {
                currentObj.showOverlay = false;
                currentObj.serverError(error);
            });
        },
        uploadFile() {
            this.file = this.$refs.file.files[0];
        },
        openUploadModal() {
            this.$bvModal.show("bv-modal-file-upload")
        },
        getYearData() {

        },
        addDeviceID: function (id) {
            this.employeeID = id;
            this.$bvModal.show("bv-modal-employee-device");
        },
        closeEmployeeDeviceModal() {
            this.$bvModal.hide("bv-modal-employee-device");
            this.$bvToast.toast('Saved!', {
                title: `Success`,
                variant: 'success',
                solid: true
            });
            this.showOverlay = false;
        },
        sortBy(key) {
            this.resetPagination();
            this.sortKey = key;
            this.sortOrders[key] = this.sortOrders[key] * -1;

            this.backdoor++;
        },
        filterList(value) {
            this.resetPagination();
            if (parseInt(value['reset']) === 1) {
                this.search_by_filter = value['search_by_filter'];
                this.sortBy('name');
                $("#filter_button").click();
            }
        },
        stringView(str) {
            var i, frags = str.split('_');
            for (i = 0; i < frags.length; i++) {
                frags[i] = frags[i].charAt(0).toUpperCase() + frags[i].slice(1);
            }
            return frags.join(' ');
        },
        getIndex(array, key, value) {
            return array.findIndex(i => i[key] == value)
        },
        toMoney: function (amount) {
            if (amount.toString() !== "0") {
                let number = 0;
                if (!isNaN(amount)) {
                    number = Number(amount);
                    return number;
                }
                var NumWithoutCommas = amount.replace(/,/g, '');
                number = Number(NumWithoutCommas).toFixed(2);
                return number;
            } else {
                return amount;
            }
        },
        generateList: function () {
            this.showOverlay = false;
            if (this.employees.length > 0) {
                let cr = {};

                if (this.company_options.length > 0) {
                    this.company_options.forEach(element => {
                        if (element.label == 'jobposition') {
                            cr['jobposition_id'] = '';
                        } else if (element.label == 'department') {
                            cr['department_id'] = '';
                        } else if (element.label == 'branch') {
                            cr['branch_id'] = '';
                        } else {
                            cr[element.label] = '';
                        }

                    });
                }

                this.search_by_filter = cr;
                let co = [];
                let cl = [];
                let dop = [];
                if (this.company_options.length > 0) {
                    this.company_options.forEach(element => {

                        if (1) {
                            cl = cl.concat([{
                                label: this.stringView(element.label),
                                name: element.label,
                                type: element.type
                            }]);

                            if (!this.default_column.includes(element.label)) {
                                co = co.concat([{text: this.stringView(element.label), value: element.label}]);
                            }
                            if (this.default_column.includes(element.label)) {
                                dop = dop.concat([{text: this.stringView(element.label), value: element.label}]);
                            }
                        }


                    });
                }
                let aop = [];
                let aopcl = [];
                for (let i = 0; i < this.appended_column.length; i++) {
                    aop = aop.concat([{
                        text: this.stringView(this.appended_column[i].text),
                        value: this.appended_column[i].value
                    }]);
                    aopcl = aopcl.concat([{
                        label: this.stringView(this.appended_column[i].text),
                        name: this.appended_column[i].value,
                        type: this.appended_column[i].type
                    }]);
                }

                this.appended_options = this.appended_options.concat(aop);
                this.default_options = this.default_options.concat(dop);
                this.column_options = this.column_options.concat(co);
                this.columns = this.columns.concat(cl);
                this.columns = this.columns.concat(aopcl);

                this.columns.forEach((column) => {
                    console.log("columns : " + column.name);
                    this.sortOrders[column.name] = -1;
                });
                if (this.employees.length == 0) {
                    if (this.is_payruns == 'yes') {
                        this.blankMsg = "Loading relevent payslips...";
                        this.show_loader = true;
                    } else {
                        this.blankMsg = "Looks like there is no relevent data here.";
                        this.show_loader = false;
                    }
                } else {
                    this.tableStickyHeight = 'table-sticky-height';
                    this.length_options = [{value: 20, text: "20"},
                        {value: 50, text: "50"},
                        {value: 100, text: "100"},
                        {value: 1500, text: "1500"}
                    ];
                    this.people = this.employees.length;
                    this.sortBy('name');
                }

            } else {
                let dop = [];
                let cl = [];
                this.default_column.forEach(element => {
                    cl = cl.concat([{label: this.stringView(element), name: element}]);
                    dop = dop.concat([{text: this.stringView(element), value: element}]);
                });
                this.columns = this.columns.concat(cl);
                this.default_options = this.default_options.concat(dop);
                if (this.is_payruns == 'yes') {
                    this.blankMsg = "Loading relevent payslips...";
                    this.show_loader = true;
                } else {
                    this.blankMsg = "Looks like there is no relevent data here.";
                    this.show_loader = false;
                }
            }


        },
        editEmployee: function (em_id) {
            if (!this.checkNet()) return false;
            this.employeeID = em_id;
            this.$bvModal.show('bv-modal-employee-policy');
        },
        closePolicyMappingModal(em_id) {
            this.$bvModal.hide('bv-modal-employee-policy');

            let value = [];
            value[this.primary_key] = em_id;
            value['action_id'] = 0;
            value['selected'] = [];
            value['column_selected'] = [];

            //this.$emit('childToParent', value);
        },
        closeCostMappingModal(em_id) {
            this.$bvModal.hide('bv-modal-employee-cost-mapping');
            this.$bvToast.toast('Saved!', {
                title: `Success`,
                variant: 'success',
                solid: true
            });
        },
        openLeaveApplyModal: function (em_id) {
            if (!this.checkNet()) return false;
            this.employeeID = em_id;
            this.$bvModal.show('bv-modal-employee-apply-leave');
        },
        openCostMappingModal: function (em_id) {
            if (!this.checkNet()) return false;
            this.employeeID = em_id;
            this.$bvModal.show('bv-modal-employee-cost-mapping');
        },
        actionEmployee: function (em_id, action_id) {
            let value = [];
            value[this.primary_key] = em_id;
            value['action_id'] = action_id;
            value['selected'] = [];
            value['column_selected'] = [];
            this.$emit('childToParent', value);
        },
        getPrimaryKey: function () {
            return this.primary_key;
        },
        getDateObj(start_month) {
            let str_month_arr = [];
            var m_names = ['january', 'february', 'march',
                'april', 'may', 'june', 'july',
                'august', 'september', 'october', 'november', 'december'];

            if (start_month.includes("-")) {
                str_month_arr = start_month.split("-");
            } else {
                str_month_arr = start_month.split(" ");
            }

            var yr1 = parseInt(str_month_arr[1]);
            var mt = str_month_arr[0];
            var mon1 = m_names.indexOf(mt);
            var d1 = new Date(yr1, mon1).getTime();
            return d1;
        },
        exportEmployee() {
            if (!this.checkNet()) return false;
            this.showOverlay = true;
            let currentObj = this;

            let formData = {
                employees: this.selected
            }

            const config = {
                headers: { 'Content-Type': 'application/json; charset=utf-8', },
                responseType: 'blob',
            }

            axios.post('export-cost-mapping', formData, config)
                .then(function (response) {
                    currentObj.showOverlay = false;
                    if(response.data.type === 'application/json') {
                        let file = new Blob([response.data],{type: 'application/json'});
                        /* if you use different error message just change the name instead of  'error_msg' */
                        const cast = Promise.resolve(file.text());
                        cast.then((value) => {
                            let err_obj = JSON.parse(`${value}`);
                            this.$bvToast.toast(err_obj.error_msg, {title: 'Error',variant: 'danger',solid: true});
                        });
                    } else {
                        this.global_download_file_content(response);
                    }
                }.bind(this)).catch(function (error) {
                currentObj.showOverlay = false;
                currentObj.serverError(error);
            });
        },
    },
    created: function () {
        if (this.all_employee == 'yes') {
            this.status_flag = true;
        }
        if (this.$cookies.isKey("column_selected")) {
            if (this.$cookies.get("column_selected") != null && this.$cookies.get("column_selected") != '')
                this.column_selected = this.$cookies.get("column_selected").split(',');
        }
        this.generateList();
        $(window).on('load', function (e) {
            setTimeout(function () {
                $('.div1').width($('table.employee-list-table').width());
                $('.div2').width($('table.employee-list-table').width());
                if ($('table.employee-list-table').width() > $('.wrapper1').width()) {
                    //alert($('table.employee-list-table').width());
                    $('.wrapper1').show();
                } else {
                    //alert('Its not bigger');
                    $('.wrapper1').hide();
                }
            }, 2000);
            $('.wrapper1').on('scroll', function (e) {
                $('.wrapper2').scrollLeft($('.wrapper1').scrollLeft());
            });
            $('.wrapper2').on('scroll', function (e) {
                $('.wrapper1').scrollLeft($('.wrapper2').scrollLeft());
            });

            $(document).on("click", ".trz-custom-dropdown .custom-switch input", function () {
                setTimeout(function () {
                    $('.div1').width($('table.employee-list-table').width());
                    $('.div2').width($('table.employee-list-table').width());
                    if ($('table.employee-list-table').width() > $('.wrapper1').width()) {
                        $('.wrapper1').show();
                    } else {
                        $('.wrapper1').hide();
                    }
                }, 500);
            });
        });
    },
    computed:
        {
            filteredData() {
                this.backdoor;

                //alert(this.backdoor);

                let filtered_list = this.employees;

                let search_by_custom_fields = this.search_by_filter;

                var search_terms = new Array();

                //always go for this
                if (search_by_custom_fields) {
                    //try to get all field's information
                    Object.keys(search_by_custom_fields).forEach(key => {
                        if (search_by_custom_fields[key] != '' && (this.column_selected.includes(key) || this.default_column.includes(key) || this.filter_by_id.includes(key))) {
                            search_terms.push(`${key}:${search_by_custom_fields[key]}`);
                        } else {
                            this.search_by_filter[key] = '';
                        }
                        //here all_employee is a props default value
                        if (this.all_employee == 'yes') {
                            if (search_by_custom_fields['status'] == '' && key == 'status') {
                                search_terms.push('status:Active');
                            }
                        }

                        /* issue

                        if(this.status_flag)
                        {
                            search_terms.push('status:Active');
                        }

                        */
                    });
                }


                if (search_terms.length > 0) {
                    for (var i = 0; i < search_terms.length; i++) {
                        const term_to_search = search_terms[i].split(":");
                        let search_key = term_to_search[0];
                        let search_value = term_to_search[1];

                        if (search_key == 'status') {
                            filtered_list = filtered_list.filter((row) => {
                                return Object.keys(row).some((key) => {
                                    return String(row[search_key]).toLowerCase().indexOf(search_value.toLowerCase()) == 0;
                                })
                            });
                        } else {
                            filtered_list = filtered_list.filter((row) => {
                                return Object.keys(row).some((key) => {
                                    return String(row[search_key]).toLowerCase().indexOf(search_value.toLowerCase()) > -1;
                                })
                            });
                        }

                    }

                    this.pagination.currentPage = 1;
                    if (filtered_list.length == 0) {
                        this.blankMsg = "Nothing found.";
                        if (this.all_employee == 'yes') {
                            if (this.search_by_filter['status'] == '' || this.search_by_filter['status'] == 'Active') {
                                this.blankMsg = "No active employee found.";
                            }
                        }
                    }

                    if (this.all_employee == 'yes') {
                        //console.log(filtered_list);
                        if (filtered_list.length > 0) {
                            if (filtered_list[0]['status'] && filtered_list[0]['status'] != '') {
                                this.status_flag = false;
                            } else {
                                this.status_flag = true;
                            }
                        }
                    }
                }

                if (this.search) {
                    filtered_list = filtered_list.filter((row) => {
                        return Object.keys(row).some((key) => {
                            return String(row[key]).toLowerCase().indexOf(this.search.toLowerCase()) > -1;
                        })
                    });


                    if (filtered_list.length === 0)
                        this.blankMsg = "Nothing found.";
                }

                let sortKey = this.sortKey;

                //if(typeof this.sortOrders[sortKey] == 'undefined')this.sortOrders[sortKey] = -1;
                //else this.sortOrders[sortKey] = 1;

                let order = this.sortOrders[sortKey] || 1;

                //alert(sortKey + ' >> ' + order);

                if (sortKey) {
                    filtered_list = filtered_list.slice().sort((a, b) => {
                            let index = this.getIndex(this.columns, 'name', sortKey);
                            a = String(a[sortKey]).toLowerCase();
                            b = String(b[sortKey]).toLowerCase();

                            if (this.columns[index].type && this.columns[index].type === 'date') {
                                return (a === b ? 0 : new Date(a).getTime() > new Date(b).getTime() ? 1 : -1) * order;
                            }
                            if (this.columns[index].type && this.columns[index].type === 'monthyear') {
                                return (a === b ? 0 : this.getDateObj(a) > this.getDateObj(b) ? 1 : -1) * order;
                            } else if (this.columns[index].type && this.columns[index].type === 'number') {
                                a = this.toMoney(a);
                                b = this.toMoney(b);

                                return (+a === +b ? 0 : +a > +b ? 1 : -1) * order;
                            } else {
                                let aa = (a === b ? 0 : a > b ? 1 : -1) * order;
                                return (a === b ? 0 : a > b ? 1 : -1) * order;
                            }
                        }
                    );
                }

                this.people = filtered_list.length;
                return filtered_list;
            },
            paginatedData() {
                this.backdoor;

                return this.paginate(this.filteredData, this.length, this.pagination.currentPage);
            },
            selectAll: {
                get: function () {
                    return this.paginatedData ? this.selected.length === this.paginatedData.length : false;
                },
                set: function (value) {
                    console.log('select all set method: ', value)
                    var selected = [];
                    var pm_key = this.getPrimaryKey();
                    if (value) {
                        this.paginatedData.forEach(function (user) {
                            if (user.pay_slip_name && user.pay_slip_name != '')
                                selected.push(user.id);
                            else {
                                if (user.locked != 1) {
                                    selected.push(user[pm_key]);
                                }

                            }
                        });
                    }
                    this.selected = selected;
                }
            },
            clickSelect() {
                if (this.selected.length != this.selected_ids.length) {
                    this.selected_ids = this.selected;
                    let value = [];
                    value[this.primary_key] = 0;
                    value['action_id'] = 0;
                    value['selected'] = this.selected;
                    value['column_selected'] = [];
                    this.$emit('childToParent', value);
                }
                if (this.is_payruns && this.is_payruns == 'yes') {
                    //this.$cookies.set("report_column_selected", this.column_selected);
                    let value = [];
                    value[this.primary_key] = 0;
                    value['action_id'] = 0;
                    value['selected'] = this.selected;
                    value['column_selected'] = this.column_selected;
                    this.$emit('childToParent', value);
                }
                this.$cookies.set("column_selected", this.column_selected);
            },
        }
}
</script>
<style>

.employee-list-table tr td:last-child {
    padding-right: 20px;
}

.action_thead {
    text-align: right;
}

.trz_disable_box + label::before {
    background: #adb5bdab !important;
}

.trz_people_btn.trz_email {
    right: 0;
    top: -185px;
}

.trz_employee_draft_edit {
    position: absolute;
    left: 12px;
    top: 18px;
}

.trz_relative {
    position: relative;
}
</style>
